import { EnhancedCheckboxRHF, RHookFormNumberFieldWithLabel } from "@websential/cosmic-v20";

import { FC } from "react";
import { Grid } from "@mui/material";
import { IDropDownListResponse } from "../../../models/common/IDropDownListResponse";

interface IEarningsSetupFieldsPanel {
  earningsFieldsList: IDropDownListResponse[]
}
export const EarningsSetupFieldsPanel: FC<
  IEarningsSetupFieldsPanel
> = ({ earningsFieldsList }) => {
  return (
    <>
      {earningsFieldsList && earningsFieldsList.length > 0 && earningsFieldsList.map((item: any) => {
        return (
          <RHookFormNumberFieldWithLabel id={`${item.value}-earnings`} testId={`${item.label}`} label={`${item.label}`} />
        )
      })}
    </>
  );
};
